<div class="top">
  <app-custom-back-button *ngIf="showBackButton"></app-custom-back-button>
  <ng-content></ng-content>
</div>

<p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>

<div class="bottom">
  <p class="title">{{ title }}</p>
  <ng-content select="[slot=bottom]"></ng-content>
</div>
